<template>
  <div class="html-content">
    <h1>이용약관</h1>
    <div v-html="usimsaTerms" />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'terms'
})

const POLICY_TERMS_ID = 'D599BAC4-2833-F111-9A49-6045BD443A50'

const { getTermsById } = useApi()
const { data: termsData } = await useAsyncData('usimsa-terms', () => getTermsById(POLICY_TERMS_ID))

const usimsaTerms = computed(() => termsData.value?.data?.content ?? '')
</script>

<style scoped lang="scss">
.html-content {
  h1 {
    margin-bottom: 36px;
  }
  a {
    display: block;
    text-decoration: underline;
  }
}
</style>
